module.exports = __webpack_public_path__ + "static/media/fridge-1.a5fde23a.jpg";